module.exports = {
  US_CON: 'Continental U.S.',
  US_AK: 'Alaska',
  US_HI: 'Hawaii',
  US_PR: 'Puerto Rico',
  US_OTHER: 'Other U.S. Territories',
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/translations/sub_regions/en.js